import { paths } from '@/constants/paths'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl/useCanonicalUrl'
import { LegalLayout } from '@/layouts/LegalLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { VideoPrivacyPolicy_2024_07_31 } from './2024-07-31'

const VideoPrivacyPolicyPage: NextPageWithLayout = () => {
  const canonical = useCanonicalUrl(paths.legal.videoPrivacyPolicy)
  const title = 'Video Privacy Policy | Angel'

  return (
    <>
      <Seo
        canonical={canonical}
        title={title}
        description="Angel Video Privacy Policy. Learn how we handle your video viewing information."
        openGraph={{
          title,
          url: canonical,
          site_name: 'Angel',
        }}
        path={paths.legal.videoPrivacyPolicy}
      />
      <VideoPrivacyPolicy_2024_07_31 />
    </>
  )
}

VideoPrivacyPolicyPage.getLayout = (page) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/legal/video-privacy-policy/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
      revalidate: false,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default VideoPrivacyPolicyPage
